'use strict';
module.exports = require('../../full/instance/last-index-of');
